import { Action } from '@ngrx/store';

export enum ErrorActionTypes {
  SET_ERROR = '[App-shared] Set Error',
}

export interface ErrorDetails {
  error: string;
  userMessage: string;
  devMessage: string;
}

export class SetErrorAction implements Action {
  readonly type = ErrorActionTypes.SET_ERROR;
  constructor(public payload: ErrorDetails) { }
}
